module.exports = __webpack_public_path__ + "static/first-step-692a63f3f2d3c06fa08d6b68b00882e8.svg";